import {StyleSheet} from '@react-pdf/renderer';

import {greenColors, orangeColors} from '../../../../../../layouts/theme/designSystem';

export const cultureTypeOverviewStyles = StyleSheet.create({
  cultureTypeContainer: {
    marginTop: 14,
    marginBottom: 6,
  },
  matchBox: {
    backgroundColor: `${orangeColors[4]}`,
    padding: 8,
    borderRadius: 4,
    borderWidth: 0.5,
    marginBottom: 10,
    marginTop: 10,
    borderStyle: 'solid',
    borderColor: `${orangeColors[5]}`,
  },
  matchText: {
    color: orangeColors[70],
    fontSize: 10,
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: '5px',
  },
  matchBarWrapper: {
    height: '27px',
    backgroundColor: '#1D4449',
    borderRadius: '4px',
    padding: '4px',
    width: '100%',
  },
  matchBar: {
    height: '19px',
    borderRadius: '2px',
    padding: '2px 8px',
    // Note: React PDF does not support linear gradients
    backgroundColor: '#E88B58',
  },
  cultureTypeDetailsContainer: {
    marginTop: 10,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  cultureTypeImageContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginRight: '10px',
    width: '80px',
    height: '80px',
  },
  cultureTypeImage: {
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    flexShrink: 0,
    objectFit: 'cover',
  },
  cultureTypeTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexBasis: 0,
  },
  cultureTypeKeywordsContainer: {
    flexDirection: 'row',
    marginTop: 10,
  },
  keyWordBox: {
    padding: 5,
    backgroundColor: `${orangeColors[5]}`,
    borderRadius: 2,
    marginRight: 8,
    color: `${greenColors[700]}`,
  },
});
